import api from '@pray/shared/utils/api';

type UpdateContentAdminFieldsParams = {
  artistId: string;
  contentId: string;
  contentArtistId?: string | null;
  premiumType?: string;
  isFeatured?: boolean;
  contentCategoryId?: string | null;
  family?: string | null;
  mediaLengthType?: string;
  seoTitle?: string | null;
  ogTitle?: string | null;
  ogDescription?: string | null;
  ogTwitterTitle?: string | null;
  sendPublishedNotification?: boolean;
};

export async function updateContentAdminFields({
  artistId,
  contentId,
  contentArtistId,
  premiumType,
  isFeatured,
  contentCategoryId,
  family,
  mediaLengthType,
  seoTitle,
  ogTitle,
  ogDescription,
  ogTwitterTitle,
  sendPublishedNotification,
}: UpdateContentAdminFieldsParams) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');

  const data: Record<string, unknown> = {};

  if (contentArtistId !== undefined) data.artist_id = contentArtistId;
  if (premiumType !== undefined) data.premium_type = premiumType;
  if (isFeatured !== undefined) data.is_featured = isFeatured;
  if (contentCategoryId !== undefined) data.content_category_id = contentCategoryId;
  if (family !== undefined) data.family = family;
  if (mediaLengthType !== undefined) data.media_length_type = mediaLengthType;
  if (seoTitle !== undefined) data.seo_title = seoTitle;
  if (ogTitle !== undefined) data.og_title = ogTitle;
  if (ogDescription !== undefined) data.og_description = ogDescription;
  if (ogTwitterTitle !== undefined) data.og_twitter_title = ogTwitterTitle;
  if (sendPublishedNotification !== undefined) data.send_published_notification = sendPublishedNotification;

  if (Object.keys(data).length === 0) return;

  const url = `/web/studio/artists/${artistId}/content/${contentId}/admin-fields`;
  await api.executePutRequest(url, data);
}
